import { InjectionToken } from '@angular/core';

/**
 * User-Agent de la petición, disponible tanto en servidor (SSR) como en cliente.
 *
 * Sirve para que `isMobile` sea DETERMINISTA y coincida server↔cliente en el primer
 * render (requisito de la hidratación: si el servidor pinta un layout y el cliente otro,
 * la hidratación rompe). En servidor se provee desde `req.headers['user-agent']`; en
 * cliente desde `navigator.userAgent` (ver main.ts y el render SSR de server.ts).
 */
export const USER_AGENT = new InjectionToken<string>('USER_AGENT');
